module.exports = __webpack_public_path__ + "img/paga_todo.1df76ec.png";